import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  ...AsyncRequest.createActionKeys('GET_ORG_STATES'),
  ...AsyncRequest.createActionKeys('GET_ORGS_BY_STATE'),
  ...AsyncRequest.createActionKeys('GET_ORG_FIELDS'),
});



// WEBPACK FOOTER //
// ./src/modules/profile/common/licenseActionKeys.js